/**
 * Check if a looker_link value is in the new object format
 */
export function isLookerLinkObject(link) {
  return link !== null && typeof link === 'object' && !Array.isArray(link);
}

/**
 * Check if a looker_link value is a valid string URL
 */
export function isLookerLinkString(link) {
  return typeof link === 'string' && link.trim().length > 0;
}

/**
 * Get an array of { name, link, lookId, sourceLookId } from an object-type looker_link
 */
export function parseLookerLinkObject(linkObj) {
  return Object.entries(linkObj).map(([name, value]) => ({
    name,
    link: value.link,
    lookId: value.look_id,
    sourceLookId: value.source_look_id,
  }));
}

/**
 * Check if a URL points to a Looker look (used to validate copy/template links)
 */
export function isValidLookerLink(url) {
  if (!url || typeof url !== 'string') return false;
  const patterns = [
    /\/looks?\/(\d+)(?:[/?#]|$)/i,       // /looks/123 or /look/123
    /\/embed\/looks?\/(\d+)(?:[/?#]|$)/i // /embed/looks/123 or /embed/look/123
  ];
  return patterns.some(p => p.test(url));
}
